<template>
  <div class="d-flex flex-row flex-wrap flex-grow-1 flex-shrink-1 mx-5 mt-3">
    <div class="d-flex flex-row flex-wrap flex-grow-1 align-content-start" style="flex-basis: 25%;">
      <v-text-field
        prepend-inner-icon="search"
        solo
        flat
        placeholder="Search categories ..."
        color="primary"
        class="ft font-weight-medium rounded-sm primary--text text-capitalize ka-search"
      />
    </div>
    <div class="d-flex flex-row flex-wrap justify-end" style="flex-basis: 25%;">
      <slot name="actions"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SearchBar',
};
</script>

<style scoped lang="scss">
.ka-search ::v-deep .v-input__slot {
  background: var(--ka-surface-2) !important;
}
</style>
